import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { appConfig as baseAppConfig } from './app-config.base';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

Sentry.init({
  dsn: 'https://63380fca5bca9b8fcd74c2bb4378ce48@o4510389507850240.ingest.us.sentry.io/4510389919416320',
  tunnel: 'https://back.goodchart.co/ap/s',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.replayCanvasIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/goodchart\.co\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

export const appConfig: ApplicationConfig = {
  ...baseAppConfig,
  providers: [
    ...baseAppConfig.providers,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
